import React from 'react';
import { cn } from '../../lib/utils';  // Update the import to use our local utility

export const FormLabel: React.FC<React.LabelHTMLAttributes<HTMLLabelElement>> = ({ children, ...props }) => (
  <label
    {...props}
    className="block text-sm font-semibold text-gray-700 mb-1 uppercase"
  >
    {children}
  </label>
);

export const FormInput: React.FC<React.InputHTMLAttributes<HTMLInputElement>> = (props) => (
  <input
    {...props}
    className="mt-1 w-full bg-white border border-gray-300 text-gray-900 placeholder-gray-500 focus:ring-[#3eaf99] focus:border-[#3eaf99] rounded-sm py-3 px-4"
  />
);

export const FormTextarea: React.FC<React.TextareaHTMLAttributes<HTMLTextAreaElement>> = (props) => (
  <textarea
    {...props}
    className="mt-1 w-full bg-white border border-gray-300 text-gray-900 placeholder-gray-500 focus:ring-[#3eaf99] focus:border-[#3eaf99] rounded-sm py-3 px-4"
  />
);

export const FormSelect: React.FC<React.SelectHTMLAttributes<HTMLSelectElement>> = (props) => (
  <select
    {...props}
    className={cn(
      "block w-full rounded-md border-2 border-gray-200 bg-white py-2 pl-3 pr-10 text-gray-900 focus:border-[#3eaf99] focus:outline-none focus:ring-0 sm:text-sm appearance-none",
      props.className
    )}
    style={{
      backgroundImage: `url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%23666' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3E%3C/svg%3E")`,
      backgroundPosition: `right 0.75rem center`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '1.5em 1.5em',
      paddingRight: '2.5rem'
    }}
  />
);

export const FormButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = ({ children, ...props }) => (
  <button
    {...props}
    className="bg-teal-500 hover:bg-teal-400 text-white py-2 px-6 rounded-md font-semibold"
  >
    {children}
  </button>
);

export const CancelButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = ({ children, ...props }) => (
  <button
    {...props}
    className="bg-gray-100 hover:bg-gray-200 text-gray-700 py-2 px-6 rounded-md font-semibold"
  >
    {children}
  </button>
);
